export const appdata = {
  carouselData: [
    {
      image: "https://i.ibb.co/gwj3kLN/bromo.jpg",
      keterangan: "Gunung Bromo",
    },
    {
      image: "https://i.ibb.co/LCW0HdH/balekambang.jpg",
      keterangan: "Pantai Balekambang",
    },
    {
      image: "https://i.ibb.co/njW1G2n/batu-Bengkung.jpg",
      keterangan: "Pantai Batu Bengkung",
    },
    {
      image: "https://i.ibb.co/k07n2Hg/guaCina.jpg",
      keterangan: "Pantai Gua Cina",
    },
    {
      image: "https://i.ibb.co/R3mcLdn/tiga-Warna.jpg",
      keterangan: "Pantai Tiga Warna",
    },
    {
      image: "https://i.ibb.co/F8SNgz3/batu.jpg",
      keterangan: "Kota Wisata Batu",
    },
  ],
  judulMain: "Layanan Jasa Tour Wisata Jawa Timur",
  judulSecond: "Sewa Mobil plus Driver",
  ketJudul:
    "Layanan Jasa Tour Wisata Jawa Timur Dan Sewa Mobil Malang – Gede Pari Trans adalah penyedia Jasa layanan Transportasi Shuttle, Layanan yang di sediakan seperti : City tour Malang, Sewa Mobil Malang Batu , Paket Wisata Malang Batu Bromo. Kami berikan layanan yang terbaik untuk anda",
  konsultasikan: "Konsultasikan dan Percayakan Perjalanan Anda Pada Kami",
  whyUs: [
    {
      judul: "Driver Profesional & Ramah",
      isi: "Driver yang kami miliki adalah driver yang sudah berpengalaman di bidangnya. Serta mengutamakan keramahan terhadap customer dengan menerapkan Senyum, Sapa, Salam.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Faadriver-profesional.gif?alt=media&token=aea3cd78-74c8-4dae-b7e6-4c5bab890294",
    },

    {
      judul: "Harga Hemat & Terjangkau",
      isi: "Harga Jasa yang kami terapkan tidak akan membuat kantong Anda terkuras, karena biaya sudah sesuai dengan apa yang Anda dapatkan. Harga bersaing dan terjangkau yang kami andalkan.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Faasaving.gif?alt=media&token=283b4b40-af0e-453f-a3a9-f6cf69379aa8",
    },
    {
      judul: "Mobil Bersih & Terawat",
      isi: "Armada kami selalu terjaga performa serta kebersihannya, dengan selalu melakukan service dan cuci rutin setiap minggu. Agar kenyamanan customer kami selalu terjaga dan tetap mempercayakan urusan transportasinya kepada kami.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Fbersih.gif?alt=media&token=cbbd2c6e-1f07-446e-ae1e-b24aef22f582",
    },
    {
      judul: "Tepat Waktu",
      isi: "Penjemputan customer selalu kami usahakan untuk tepat waktu, agar segala urusan dan keperluan customer dapat segera terlaksana dengan lancar tanpa ada hambatan mengenai problem penjemputan yang lama.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Faajadwal.gif?alt=media&token=29f73b53-e9f9-455b-9ba8-aedd1fd15303",
    },
    {
      judul: "Booking Mudah",
      isi: "Anda dapat dengan mudah melakukan order atau booking melalu website ini dengan masuk pada ORDER NOW atau CALL NOW, atau Anda bisa langsung menghubungi kami. Kami akan melayani Anda sebaik mungkin dan Fast Respond.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Faabooking.gif?alt=media&token=c5dfc0f1-8542-493c-a0cf-c17e590f4876",
    },
    {
      judul: "Layanan 24 Jam",
      isi: "Layanan customer service kami selalu aktif selama 24 Jam non-stop. Memberikan kemudahan untuk Anda yang baru bisa melakukan order di luar jam kerja normal.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/whyus%2Faa24jam.gif?alt=media&token=1ae1d543-d48b-4a1a-8cf9-4e3370c0cc20",
    },
  ],
  armadalData: [
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Faaa.jpeg?alt=media&token=b0198644-ad70-45ff-97c6-9bd9c6bca1cd",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fbus%20pariwisata.jpeg?alt=media&token=c82b335c-a5e1-4823-92f2-9115b4fabaf6",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fbus%20pariwisata2.jpeg?alt=media&token=fbeb9151-5f5a-46cc-8dbd-11e1eb270907",

      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fdaihatsu%20grand%20max.jpeg?alt=media&token=6f6a2fc1-5b50-4dab-9dad-2215c313b2df",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Felf%20long.jpeg?alt=media&token=2a13592f-bb3d-4f19-bbc3-7ff60702e79c",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fgaktau2.jpeg?alt=media&token=c6595b39-9d7c-43e7-ba51-fb563a840194",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fgaktau3.jpeg?alt=media&token=e49f08e2-c874-47c3-8f9c-271e7b8f484f",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fgrandmax%20(2).jpeg?alt=media&token=fc73e58d-0bfe-4f76-8df8-803ece12412c",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fjetbus2.jpeg?alt=media&token=b25cc85d-7d5c-49ae-9ee9-bae0b2bd9d40",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Fready1.jpg?alt=media&token=45370e42-10e3-4608-961a-3628be540c51",
      keterangan: "",
    },
    {
      image:
        "https://firebasestorage.googleapis.com/v0/b/gedeparitrans.appspot.com/o/armada%2Ftoyota%20(2).jpeg?alt=media&token=ae9de028-8ced-475f-a92a-387a21b4344e",
      keterangan: "",
    },
  ],
  produk: [
    {
      image: "https://i.ibb.co/pbH3nBD/wisata-2.jpg",
      nama: "City Tour Malang-Batu",
      subNama: "Grand Max kapasitas 6-7 orang",
      harga: "Rp 500.000",
      keterangan:
        "Include: Driver & BBM\nTidak Termasuk tiket masuk dan parkir",
    },
    {
      image: "https://i.ibb.co/v4CsZK0/pantai-balekambang.jpg",
      nama: "Wisata Pantai Malang Selatan",
      subNama: "Grand Max kapasitas 6-7 orang",
      harga: "Rp 550.000",
      keterangan:
        "Include: Driver & BBM\nTidak Termasuk tiket masuk dan parkir",
    },
    {
      image: "https://i.ibb.co/jrCYg3v/wisata-bromo.jpg",
      nama: "Wisata Bromo",
      subNama: "Grand Max kapasitas 6-7 orang",
      harga: "Rp 1.500.000",
      keterangan:
        "Include: Driver & BBM\nTidak Termasuk tiket masuk dan parkir",
    },
  ],
  waAdmin: "+6285700500836",
};
